export default __webpack_public_path__ + "static/media/email-verified.66a6a64f.png";